<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="35.9999"
      cy="24.7453"
      r="12.7553"
      stroke="currentcolor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.99 60.01C11.99 52.5519 18.0375 46.5043 25.4956 46.5043H33.2478"
      stroke="currentcolor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M49.5058 45.0038V63.0113"
      stroke="currentcolor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M58.5094 45.0038V63.0113"
      stroke="currentcolor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.0037 58.5094H63.0112"
      stroke="currentcolor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.0037 49.5056H63.0112"
      stroke="currentcolor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3314_39878"
        x1="23.2446"
        y1="37.5006"
        x2="48.7553"
        y2="11.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentcolor" />
        <stop offset="0.651042" stop-color="#006187" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3314_39878"
        x1="11.99"
        y1="60.01"
        x2="24.216"
        y2="40.7662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentcolor" />
        <stop offset="0.651042" stop-color="#006187" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3314_39878"
        x1="48.0051"
        y1="63.0113"
        x2="53.8454"
        y2="62.0379"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentcolor" />
        <stop offset="0.651042" stop-color="#006187" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3314_39878"
        x1="57.0088"
        y1="63.0113"
        x2="62.8491"
        y2="62.0379"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentcolor" />
        <stop offset="0.651042" stop-color="#006187" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3314_39878"
        x1="45.0037"
        y1="60.01"
        x2="45.977"
        y2="54.1697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentcolor" />
        <stop offset="0.651042" stop-color="#006187" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3314_39878"
        x1="45.0037"
        y1="51.0063"
        x2="45.977"
        y2="45.166"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentcolor" />
        <stop offset="0.651042" stop-color="#006187" />
      </linearGradient>
    </defs>
  </svg>
</template>
